import PropTypes from 'prop-types';

const IQMType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  picture_url: PropTypes.string,
  position: PropTypes.string,
  primary_phone: PropTypes.string,
  primary_phone_type: PropTypes.string,
  surface_type: PropTypes.string,
  active: PropTypes.bool.isRequired,
  pending: PropTypes.bool,
  workrooms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })).isRequired,
});

export default IQMType;



// WEBPACK FOOTER //
// ./client/app/shared/types/iqm.js